export default {
  paywall: {
    actions: {
      notNow: "Non ora",
      noThanks: "No grazie",
      skip: "Salta",
    },
    generic: {
      title: "Sblocca l'esperienza completa",
      subtitle: "Accedi a tutto ciò che ti serve per ricercare, costruire e piazzare scommesse più intelligenti",
      whyJoin: "Perché unirsi a Linemate+?",
      comparePlans: "Confronta piani",
      renewalDisclaimer: "Il piano si rinnova automaticamente. Annulla quando vuoi.",
    },
    sources: {
      injuryImpact: {
        title: "Sblocca Impatto infortuni",
        subtitle: "Scopri come gli infortuni influenzano i compagni.\nApprofondisci ogni trend",
      },
      startingLineups: {
        title: "Sblocca formazioni iniziali",
        subtitle: "Trova valore quando cambiano le formazioni iniziali.\nApprofondisci ogni trend",
      },
      opponentRank: {
        title: "Sblocca ranking difensivo avversario",
        subtitle: "Sfrutta matchup difensivi favorevoli.\nApprofondisci ogni trend",
      },
      weatherReport: {
        title: "Sblocca meteo",
        subtitle: "Usa vento e meteo a tuo vantaggio.\nApprofondisci ogni trend",
      },
      startingPitchers: {
        title: "Sblocca lanciatori partenti avversari",
        subtitle: "Mira agli spot contro lanciatori vulnerabili.\nApprofondisci ogni trend",
      },
    },
    features: {
      injuryImpact: {
        title: "Impatto infortuni",
        description: "Scopri come gli infortuni influenzano i compagni.",
      },
      startingLineups: {
        title: "Formazioni iniziali",
        description: "Trova valore quando cambiano le formazioni iniziali.",
      },
      opponentRank: {
        title: "Ranking difensivo avversario",
        description: "Sfrutta matchup difensivi favorevoli.",
      },
      weatherReport: {
        title: "Meteo",
        description: "Usa vento e meteo a tuo vantaggio.",
      },
      startingPitchers: {
        title: "Lanciatori partenti avversari",
        description: "Mira agli spot contro lanciatori vulnerabili.",
      },
    },
    comparison: {
      title: "Funzionalità",
      free: "Gratis",
      rows: {
        dailyTeamAndPlayerTrends: "Trend giornalieri squadra e giocatore",
        dailyParlayTrends: "Trend parlay giornalieri",
        teamAndPlayerPropsTool: "Strumento props squadra e giocatore",
        statsAndStandings: "Statistiche e classifiche",
        dailyCheatsheets: "Schede rapide giornaliere",
        advancedSignalsAndTools: "Segnali e strumenti avanzati",
        startingLineups: "Formazioni iniziali",
        injuryImpact: "Impatto infortuni",
        opponentDefensiveRank: "Ranking difensivo avversario",
        weatherReports: "Meteo",
        startingOpponentPitchers: "Lanciatori partenti avversari",
      },
    },
    plans: {
      bestValue: "Miglior valore",
      annual: "Annuale",
      monthly: "Mensile",
      yearlyPlan: "Piano annuale",
      monthlyPlan: "Piano mensile",
      perYearShort: "anno",
      perMonthShort: "mese",
    },
    onboarding: {
      trialTitle: "Inizia la prova gratuita di 7 giorni",
      trialSubtitle: "Scegli un piano per continuare dopo la prova",
    },
    cta: {
      claimYourCode: "Riscatta il tuo codice",
      startYourFreeTrial: "Inizia la prova gratuita",
      startMy7DayFreeTrial: "Inizia la mia prova gratuita di 7 giorni",
      tryFreeAndSubscribe: "Prova gratis e abbonati",
      upgradeToLinematePlus: "Passa a Linemate+",
    },
    trial: {
      sevenDaysFree: "7 giorni gratis",
      thenPerMonth: "{{trial}}, poi {{price}} al mese",
      thenPerYear: "{{trial}}, poi {{price}} all'anno ({{monthlyPrice}}/{{perMonthShort}})",
      startingOn: " a partire dal {{date}}",
      standardPerMonth: "{{price}} al mese",
      standardPerYear: "{{price}} all'anno ({{monthlyPrice}}/{{perMonthShort}})",
      subtitleSuffix: " con prova gratuita di 7 giorni.",
    },
  },
};
